import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { authAPI, CourseAPI } from 'service';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [courseOverview, setCourseOverview] = useState()


  const getCourseOverview = useCallback(async () => {
    try {
      const response = await CourseAPI.overview();
      if (response.success) {
        setCourseOverview(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching course overview:', error);
    }
  }, []);

  useEffect(() => {
    const initialize = async () => {
      const token = localStorage.getItem('authToken');

      if (!token) {
        setLoading(false);
        return;
      }

      const result = await authAPI.autologin();

      if (result.success) {
        setUser(result.data);
      } else {
        localStorage.removeItem('authToken');
        localStorage.removeItem('user');
        setUser(null);
        window.location.href = '/authentication-login';
      }

      setLoading(false);
    };



    initialize();

    getCourseOverview();
  }, []);



  const login = async (email, password) => {
    setLoading(true);
    try {
      const response = await authAPI.login(email, password);
      if (response.success) {
        setUser(response.data.user);
        getCourseOverview();
        return { success: true };
      } else {
        return { success: false, error: response.error };
      }
    } catch (error) {
      return { success: false, error: error.message };
    } finally {
      setLoading(false);
    }
  };


  const logout = async () => {
    await authAPI.logout();
    setUser(null);
    window.location.href = '/authentication-login';
  };


  const value = {
    user,
    loading,
    login,
    logout,
    courseOverview,
    getCourseOverview,
    isAuthenticated: !!user
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};